import styled from 'styled-components';
import { variant } from 'styled-system';

import { theme } from '../../../../common/ui/theme';

export interface MetaInformationProps {
    variant: 'accent' | 'positive' | 'negative' | 'neutral' | 'attention';
}

export const MetaInformation = styled.div<MetaInformationProps>`
    display: flex;
    align-items: center;
    column-gap: ${theme.space[4]};
    white-space: nowrap;
    border-radius: ${theme.radii[4]};
    padding: ${theme.space[4]} ${theme.space[8]};

    ${variant({
        prop: 'variant',
        variants: {
            accent: {
                color: theme.colors.accent.tint,
                background: theme.colors.accent.background,
            },
            positive: {
                color: theme.colors.positive.tint,
                background: theme.colors.positive.background,
            },
            negative: {
                color: theme.colors.negative.tint,
                background: theme.colors.negative.background,
            },
            neutral: {
                color: theme.colors.foreground.default,
                background: theme.colors.background.inset,
            },
            attention: {
                color: theme.colors.attention.tint,
                background: theme.colors.attention.background,
            },
        },
    })}
`;
